import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';


  // import { HttpHeaders } from '@angular/common/http';
 //  import {BranchElement} from "../../Models/ApplicationModels/BranchModel";
//   import {WareHouseElement} from "../../Models/ApplicationModels/WareHouseModel";


@Injectable()
export class LoginService {

private apiUrl = environment.apiUrl;

constructor(private http: HttpClient) {}


  // login(name, password, compid, branchid) {
  //   var httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //       "Access-Control-Allow-Origin": "*",
  //       "Access-Control-Allow-Credentials": "true",
  //       "Access-Control-Allow-Headers": "Content-Type",
  //       "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
  //       key: "x-api-key",
  //       value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
  //     }),
  //   };
  //   return this.http.get(
  //     `https://adminapisnew.hideandskin.in/api/AppUserMaster/GetAllAppUserByUserPassCompBra?username=${name}&password=${password}&compid=${compid}&branchid=${branchid}`,
  //     httpOptions
  //   );
  // }



  login(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  return this.http.post(""+this.apiUrl+"/AppUserMaster/AddLogin", JSON.stringify(data),httpOptions);

  }


  register(data) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };
    return this.http.post(""+this.apiUrl+"/AppUserMaster/AddAppUser",JSON.stringify(data),httpOptions);

  }


  
  sendquerysubmit(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  return this.http.post(""+this.apiUrl+"/Bill/SendQuery", JSON.stringify(data),httpOptions);

  }

  
  sendjoinsubmit(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  return this.http.post(""+this.apiUrl+"/Bill/SendJoin", JSON.stringify(data),httpOptions);

  }
  
  sendqueryCustomizeOrdersubmit(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  return this.http.post(""+this.apiUrl+"/Bill/SendQueryCustomizeOrder", JSON.stringify(data),httpOptions);
 
  }


  getAllAppUserByIdData(userid:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/AppUserMaster/GetAllAppUserById?UserId="+userid,httpOptions);

  }



  createOrder(data) {
    var httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Basic ' + btoa("rzp_live_56cRurkINfLrXS:l9JfT9Gfsm2S0kwbY0xRz8Jy")
      })
    };

     return this.http.post("https://api.razorpay.com/v1/orders",JSON.stringify(data),httpOptions);

    //return this.http.post("https://api.razorpay.com/v1/orders", httpOptions);

  }


   RazorcrteOrder(data) {
    var httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Basic ' + btoa("rzp_live_56cRurkINfLrXS:l9JfT9Gfsm2S0kwbY0xRz8Jy")
      })
    };

    return this.http.post("https://api.razorpay.com/v1/orders",JSON.stringify(data),httpOptions);
    
  }


  RazorcreateOrder(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  return this.http.post(""+this.apiUrl+"/WebsiteHome/CreateOrder", JSON.stringify(data),httpOptions);

  }

  getPasswordReset(usernames:string) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/ApplicationEntriesDetails/GeneratePassword?username="+usernames,httpOptions);

  }

  getTraceDeviceData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };  
   
  // return this.http.get(""+this.apiUrl+"/api/AppUserMaster/GetAllAppUser",httpOptions);

  return this.http.get(""+this.apiUrl+"/AppUserMaster/GetTraceDevice",httpOptions);

  }   
         


}
